import { Injectable } from '@angular/core';
import { GenericService, api } from './generic.service';
import { Modules } from '../models/modules';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class ModulesService {

  constructor(private servicegeneric: GenericService) { }

  saveModules(modules: Modules, document_id, user_id) {
    let newmodules = JSON.stringify(modules);
    let params = {
      'modules': newmodules,
      'user_id': user_id.toString(),
      'document_id': document_id.toString()
    }

    this.servicegeneric.servicehttp.post(api.SAVE_MODULES, params).subscribe(() => { });
  }

  getModules(): Observable<Modules> {
    let params = {
      'user_id': this.servicegeneric.currentuser.id.toString(),
      'document_id': this.servicegeneric.currentdocument.id.toString()
    }

    return this.servicegeneric.servicehttp.post(api.SAVED_MODULES, params).map((modules: Modules) => {
      return modules;
    });
  }

}



// WEBPACK FOOTER //
// C:/Users/Quentin/projets/kontractor/src/app/services/modules.service.ts